<section class="file-content-editor">
  <header class="file-content-editor__header">
    <div>
      <h3>{{ label }}</h3>
      @if (showFileName) {
        @if (fileName) {
          <span>{{ fileName }}</span>
        } @else {
          <span>Nenhum arquivo selecionado</span>
        }
      }
    </div>

    <div class="file-content-editor__actions">
      @if (allowUpload) {
        <idba-file-selector
          [accept]="accept"
          [extensions]="config.extensions"
          [mimeTypes]="config.mimeTypes"
          [maxSize]="maxFileSize"
          [disabled]="disabled || !config.editing"
          readMode="text"
          (fileSelected)="receiveFile($event)"
          (fileError)="showFileError($event)"
        />
      }
      @if (canFormat) {
        <button mat-raised-button color="action" type="button" [disabled]="!value" (click)="formatContent()">
          <mat-icon>format_align_left</mat-icon>
          Formatar
        </button>
      }
      @if (canPreview) {
        <button mat-raised-button color="action" type="button" (click)="toggleMode()">
          <mat-icon>{{ previewMode ? 'code' : 'visibility' }}</mat-icon>
          {{ previewMode ? codeLabel : previewLabel }}
        </button>
      }
      @if (allowDownload) {
        <button mat-raised-button color="action" type="button" [disabled]="!value" (click)="download()">
          <mat-icon>download</mat-icon>
          Baixar
        </button>
      }
      @if (allowClear) {
        <button mat-raised-button color="delete" type="button" [disabled]="disabled || !config.editing || (!value && !fileName)" (click)="clear()">
          <mat-icon>delete</mat-icon>
          Limpar
        </button>
      }
    </div>
  </header>

  @if (fileError) {
    <div class="file-content-editor__error">{{ fileError }}</div>
  }

  @if (previewMode && canPreview) {
    <div class="file-content-editor__preview">
      <div class="file-content-editor__preview-title">Pré-visualização</div>
      <iframe title="Pré-visualização do conteúdo HTML" sandbox="" [srcdoc]="previewHtml"></iframe>
    </div>
  } @else {
    <ngx-monaco-editor
      class="file-content-editor__monaco"
      [options]="editorOptions"
      [ngModel]="value"
      (ngModelChange)="setValue($event)"
      (blur)="markTouched()"
    />
  }
</section>
